/**
 * 创建人：zll
 * 时间：2020-08-12 
 * 描述：选项卡
 * 使用说明: 
 * 更新记录: 
 */
import { Component, OnInit, Input, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'sw-tab-control',
  templateUrl: './sw-tab-control.component.html',
  styleUrls: ['./sw-tab-control.component.css']
})
export class SwTabControlComponent implements OnInit {

  /**
   * 输入属性--选项卡数组: [{id:'1',text:'选项卡1'}]
   */
  @Input() tabControls:any[] = []
  
  /**
  * 输入属性--选项卡默认选中的数据id
  */
 @Input() defaultSelectedId:string = ""
  
  /**
  * 输入属性--是否在右侧有更多按钮,默认没有
  */
  @Input() hasMore:boolean = false

   /**
  * 选项卡类型：
  * 1代表选项卡为一般选项卡，即分割线在底侧（对应的位置一批top，bottom，left，right）。 
  * 2代表选项卡为之前tabset组件的选项卡，即分割线在右侧（对应的位置一批top，bottom，left，right）。
  * 3代表选项卡为块状选项卡、即分割线为块形边框（对应的位置一批top，bottom）
  * 4代表选项卡为块状选项卡、有背景图，且只有两种方向 （对应的位置一批left，right）
  */
  @Input() type:number = 1
  /**
  * 输入属性--组件显示的位置，默认 top , 还有 bottom , left , right
  */
  @Input() tabPosition:string = 'top'
  /**
  * 输入属性--选项卡标题
  */
 @Input() title:string = ''
 /**
  * 是否特殊样式 =》常用于统计查询栏
  */
 @Input() isSpecial:boolean = false
  /**
   * 将选中的选项卡抛出
   */
  @Output() ovtedTab = new EventEmitter(); 

  /**
   * 将选中的选项卡抛出
   */
  @Output() ovtedMore = new EventEmitter(); 

  /**
   * 当选项卡tabPosition方向为top或bottom时，判断选项卡右边是否有业务端自定义的内容，如按钮工具栏，搜索等，默认为false（没有）
   */
  @Input() hasRightTab:boolean = false;
    /**
  * 最小宽度 type为4
  */
   @Input() minWidth:string = '85px'
    /**
  * 最小高度 type为4
  */
  @Input() minHeigth:string = '66px'
   /**
   * 业务端自定义的内容放在选项卡右边
   * @ignore
   */
  @ContentChild('customContent') customContentTmpl: TemplateRef<any>;
  /**
   * 点击选项卡
   * @ignore
   */
  selectedId:string = ""

  constructor() { }

  ngOnInit() {
    //一开始就默认选中的数据
    if(this.defaultSelectedId || this.tabControls.length){
      this.selectedId = this.defaultSelectedId || this.tabControls[0]['id']
      let data = this.tabControls.find(v=>v.id == this.selectedId)
      //将选中数据抛出
      this.ovtedTab.emit(data)
    }
  }

  /**
   * 点击选项卡
   * @ignore
   */
  clickTab(data,i){
    this.selectedId = data.id
    //将选中数据抛出
    this.ovtedTab.emit(data)
  }

  /**
   * 点击更多
   * @ignore
   */
  clickMore(){
    this.ovtedMore.emit(this.selectedId)
  }
}
